import {ReceiptInfoVo} from '../../common/shared/api/nicolas/vo/billing/ReceiptInfoVo.interface';
import {ReceiptInfo, ReceiptInfoType} from '../generated/types';

export function createReceiptInfo({
  account_id,
  receipt_info_type,
  receipt_info,
}: ReceiptInfoVo): ReceiptInfo {
  return {
    accountId: account_id,
    receiptInfoType: receiptInfoTypeMap[receipt_info_type],
    receiptInfo: receipt_info,
  };
}

export const receiptInfoTypeMap: {[key: string]: ReceiptInfoType} = {
  1: ReceiptInfoType.PersonalPhone,
  2: ReceiptInfoType.PersonalCard,
  3: ReceiptInfoType.BusinessNumber,
  4: ReceiptInfoType.BusinessCard,
  5: ReceiptInfoType.Self,
};
